import { render, staticRenderFns } from "./QueueSelectionArenaNew.vue?vue&type=template&id=24b2da66&scoped=true"
import script from "./QueueSelectionArenaNew.vue?vue&type=script&lang=js"
export * from "./QueueSelectionArenaNew.vue?vue&type=script&lang=js"
import style0 from "./QueueSelectionArenaNew.vue?vue&type=style&index=0&id=24b2da66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b2da66",
  null
  
)

export default component.exports